const addModerationClass = () => {
  const body = document.getElementsByTagName("body");
  body.length > 0 && body[0].classList.add("moderation");
}
const removeModerationClass = () => {
  const body = document.getElementsByTagName("body");
  body.length > 0 && body[0].classList.remove("moderation");
}

export {addModerationClass, removeModerationClass};